/**
 * 接口错误码
 */
export enum ERROR_CODE {
  /**
   * 邮箱或手机号已存在
   */
  EMAIL_OR_MOBILE_EXIST = 30129,

  /**
   * 录入的公司与邮箱在黑名单中
   */
  COMPANY_AND_EMAIL_IN_BLACKLIST = 1804123,

  /**
   * 谷歌注册邮箱已存在，需要密码校验
   */
  GOOGLE_NEED_PASSWORD_CONFIRM = 31630,

  /**
   * LinkedIn 邮箱已存在，需要密码校验
   */
  LINKED_IN_NEED_PASSWORD_CONFIRM = 31619,

  /**
   * 账户未激活
   */
  ACCOUNT_STATUS_ACTIVE = 30177,

  /**
   * 域名限制
   */
  DOMAIN_RESTRICT = 30145,

  /**
   * IP 限制
   */
  IP_RESTRICT = 30108,

  /**
   * 钉钉限制
   */
  DING_TLK = 30173,

  /**
   * 飞书限制
   */
  FEISHU = 30175,

  /**
   * 企业微信限制
   */
  WECHAT_ENTERPRISE = 30174,

  /**
   * JWT 限制
   */
  JWT = 30176,

  /**
   * unknown
   */
  OTHERS = 30142

}
